<mat-form-field class="birthdate-field">
    <input class="birthdate-input cursor-pointer" matInput [matDatepicker]="picker" (click)="picker.open()" [disabled]="" [formControl]="birthdate" [max]="maxDate">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker startView="multi-year" [disabled]="false" (opened)="disableInput()" (closed)="enableInput()"></mat-datepicker>
</mat-form-field>
<mat-error *ngIf="birthdate.touched && birthdate.invalid" translate>
    missing.information.form.birthday.error
</mat-error>
